export interface WorkShift {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: unknown;
  ownerList?: unknown;
  deletedBy?: unknown;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  from: string;
  to: string;
  type: number;
  orgId: number;
  workShiftWorkingHours?: WorkShiftWorkingHour[];
  earliestTimeCheckIn?: number;
  lateTimeCheckIn?: number;
  invalidTimeCheckIn?: number;

  earlyTimeCheckOut?: number;
  invalidTimeCheckOut?: number;
  validDayValue?: number;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface WorkShiftListRequest {
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}

export type WorkShiftCreateRequest = {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  from: string;
  to: string;
  type: number;
  workShiftWorkingHours: WorkShiftWorkingHour[];
  status: number;
} & Pick<
  WorkShift,
  | "earliestTimeCheckIn"
  | "lateTimeCheckIn"
  | "invalidTimeCheckIn"
  | "earlyTimeCheckOut"
  | "invalidTimeCheckOut"
  | "validDayValue"
>;

export interface WorkShiftWorkingHour {
  id?: string;
  dayOfWeek: number;
  timeWorkFrom?: string;
  timeWorkTo?: string;
  haveBreakTime: boolean;
  breakTimeFrom?: string;
  breakTimeTo?: string;
  totalHours: number;
  workingDays: number;
  workShiftId?: string;
  status: number;
}

export interface WorkShiftUpdateRequest extends WorkShiftCreateRequest {
  id: string;
}

export interface WorkShiftListResponse extends RestAPIMetaResponse {
  items: Array<WorkShift>;
}

export enum WorkShiftType {
  Fixed = 1,
  Dynamic = 3,
}
